import { render, staticRenderFns } from "./NoOrderId.vue?vue&type=template&id=8a67393a&scoped=true"
import script from "./NoOrderId.vue?vue&type=script&lang=js"
export * from "./NoOrderId.vue?vue&type=script&lang=js"
import style0 from "./NoOrderId.vue?vue&type=style&index=0&id=8a67393a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a67393a",
  null
  
)

export default component.exports